// Utilities for managing multiple cart tabs in localStorage
const TABS_KEY = 'cart_tabs_v1'
const ACTIVE_KEY = 'cart_active_v1'
const COUNTER_KEY = 'cart_tabs_counter_v1'

export function getTabs(){
    try{
        const raw = localStorage.getItem(TABS_KEY)
        if(!raw) return []
        return JSON.parse(raw)
    }catch(e){
        return []
    }
}

export function saveTabs(tabs){
    try{
        localStorage.setItem(TABS_KEY, JSON.stringify(tabs))
    }catch(e){}
}

export function getActiveId(){
    return localStorage.getItem(ACTIVE_KEY)
}
export function setActiveId(id){
    if(id) localStorage.setItem(ACTIVE_KEY, id)
    else localStorage.removeItem(ACTIVE_KEY)
}

export function ensureInit(currentCart){
    const tabs = getTabs()
    if(tabs.length === 0){
        const counter = getCounter() || 1
        const t = { id: `tab-1`, name: `Tab ${counter}`, items: Array.isArray(currentCart)? currentCart : [] }
        saveTabs([t])
        setActiveId(t.id)
        // ensure counter is set
        setCounter(counter)
        return [t]
    }
    // if there is no active id, set to first
    if(!getActiveId()) setActiveId(tabs[0].id)
    return tabs
}

export function createNewTab(prevCart){
    const tabs = getTabs()
    if(tabs.length >= 4) return null
    const counter = incrementCounter()
    const id = `tab-${Date.now()}`
    const name = `Tab ${counter}`
    // save prevCart to currently active
    const active = getActiveId()
    if(active){
        const idx = tabs.findIndex(t=>t.id===active)
        if(idx>=0) tabs[idx].items = Array.isArray(prevCart)? prevCart : []
    }
    const newTab = { id, name, items: [] }
    tabs.push(newTab)
    saveTabs(tabs)
    setActiveId(id)
    return { tabs, newTab }
}

function getCounter(){
    try{ const v = localStorage.getItem(COUNTER_KEY); return v? parseInt(v,10): null }catch(e){return null}
}
function setCounter(n){
    try{ localStorage.setItem(COUNTER_KEY, String(n)) }catch(e){}
}
function incrementCounter(){
    const cur = getCounter() || 0
    const next = cur + 1
    setCounter(next)
    return next
}

export function switchToTab(tabId, currentCart){
    const tabs = getTabs()
    const active = getActiveId()
    // save current cart to active tab
    if(active){
        const idx = tabs.findIndex(t=>t.id===active)
        if(idx>=0) tabs[idx].items = Array.isArray(currentCart)? currentCart : []
    }
    // set active to tabId
    setActiveId(tabId)
    saveTabs(tabs)
    const target = tabs.find(t=>t.id===tabId)
    return target ? target.items : []
}

export function updateActiveTabItems(items){
    const tabs = getTabs()
    const active = getActiveId()
    if(!active) return
    const idx = tabs.findIndex(t=>t.id===active)
    if(idx>=0){
        tabs[idx].items = Array.isArray(items)? items : []
        saveTabs(tabs)
    }
}

export function closeTab(tabId){
    let tabs = getTabs()
    const active = getActiveId()
    tabs = tabs.filter(t => t.id !== tabId)
    saveTabs(tabs)
    if(active === tabId){
        if(tabs.length > 0){
            setActiveId(tabs[0].id)
            return tabs[0]
        }else{
            setActiveId(null)
            return null
        }
    }
    return null
}

export function removeActiveTabAndReturnNext(){
    let tabs = getTabs()
    const active = getActiveId()
    if(!active) return null
    tabs = tabs.filter(t => t.id !== active)
    saveTabs(tabs)
    if(tabs.length>0){
        setActiveId(tabs[0].id)
        return tabs[0]
    }
    setActiveId(null)
    return null
}

export function clearAllTabs(){
    localStorage.removeItem(TABS_KEY)
    localStorage.removeItem(ACTIVE_KEY)
}
